import { useIntl } from 'react-intl';

import { Label, LabelVariant } from '@ets/design-system';

import { Status as StatusLabel } from '_common/components';
import styles from './Status.module.scss';

import { useSelector } from '_common/hooks';

type StatusProps = { oldStatusId: string; newStatusId: string; testId: string };

const TASK_STATUS = {
  td: 'TODO',
  pr: 'IN_PROGRESS',
  d: 'auth.login.done',
  [`TO-DO`]: 'TODO',
  [`IN PROGRESS`]: 'IN_PROGRESS',
  DONE: 'auth.login.done',
};

const Status = ({ oldStatusId, newStatusId, testId }: StatusProps) => {
  const intl = useIntl();
  const isPdf = useSelector((state) => state.pdf.general.pdfId);
  const isEditor = useSelector((state) => state.editor.status.visible);

  const renderTaskStatus = (statusId: keyof typeof TASK_STATUS, testId: string) => {
    const status: { name: string; color: LabelVariant } = { name: '', color: 'grey' };
    status.name = intl.formatMessage({ id: TASK_STATUS[statusId] }).toUpperCase();

    switch (statusId) {
      case 'TO-DO':
      case 'td':
        status.color = 'grey';
        break;
      case 'IN PROGRESS':
      case 'pr':
        status.color = 'blue';
        break;
      case 'DONE':
      case 'd':
        status.color = 'green';
        break;
      default:
        break;
    }

    return (
      <Label variant={status.color} size={isPdf || !isEditor ? 's' : 'm'} testId={testId}>
        {status.name}
      </Label>
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        {oldStatusId === 'td' ||
        oldStatusId === 'pr' ||
        oldStatusId === 'd' ||
        oldStatusId === 'TO-DO' ||
        oldStatusId === 'IN PROGRESS' ||
        oldStatusId === 'DONE' ? (
          renderTaskStatus(oldStatusId, `${testId}-old-${oldStatusId}`)
        ) : (
          <StatusLabel id={oldStatusId} size="s" testId={`${testId}-old-${oldStatusId}`} />
        )}
        <div className={styles.arrow}>→</div>
        {newStatusId === 'td' ||
        newStatusId === 'pr' ||
        newStatusId === 'd' ||
        newStatusId === 'TO-DO' ||
        newStatusId === 'IN PROGRESS' ||
        newStatusId === 'DONE' ? (
          renderTaskStatus(newStatusId, `${testId}-new-${newStatusId}`)
        ) : (
          <StatusLabel id={newStatusId} size="s" testId={`${testId}-new-${newStatusId}`} />
        )}
      </div>
    </div>
  );
};
export default Status;
